export const CRITICAL = 'Critical';
export const ACTION_HIDE = 'hide';
export const ACTION_UNHIDE = 'unhide';
export const ALERT_KEY_HOLDS = 'holds';
export const ALERT_KEY_UPCOMING_HOLDS = 'upcomingHolds';
export const ALERT_KEY_BALANCE = 'balance';
export const ALERT_KEY_FINANCIAL_AID = 'financialAid';
export const ALERT_KEY_STUDENT_PROGRESS_NOTIFICATIONS = 'studentProgressNotifications';
